import React, { useState, useEffect } from "react";
import { Box, Grid2, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import ServiceProviderList from "../ServiceProviders/ServiceProviderList";
import SubServicesCard from "../SubServicesCard";
import HowItWorks from "./HowItWorks";
import LoadingAnimation from "../../Animations/LoadingAnimation";
import { fonts, headingFonts, semiBoldFonts } from "../../../Styles/Styles";

export default function SubServicesPage() {
  const { serviceId } = useParams(); // Assuming `id` corresponds to the service ID
  const [subServices, setSubServices] = useState([]);
  const [serviceName, setServiceName] = useState([]);
  const [serviceImage, setServiceImage] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSubServices = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_SERVER_BASE_URL}/services/subservices/${serviceId}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        const data = await response.json();
        setSubServices(data.subServices || []);
        setServiceName(data.serviceName);
        setServiceImage(data.serviceImage);
      } catch (error) {
        console.error("Error fetching sub-services:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchSubServices();
  }, [serviceId]);

  return (
    <Box>
      <Box
        sx={{
          position: "relative",
          width: "100%",
          height: "50vh",
          backgroundImage: `url(${serviceImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          color: "white",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
          }}
        />
        <Box sx={{ position: "relative", zIndex: 1, textAlign: "center" }}>
          <Typography
            variant="h4"
            sx={{
              ...semiBoldFonts,
              letterSpacing: 2,
              textTransform: "uppercase",
            }}
          >
            {serviceName}
          </Typography>
          <Typography variant="h6" color="white" mt={1} sx={{ ...fonts }}>
            Browse through list of {serviceName} to find the service provider
            for your needs.
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          p: 3,
          width: "95%",
          margin: "0 auto",
        }}
      >
        {loading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "200px",
            }}
          >
            <LoadingAnimation />
          </Box>
        ) : (
          <>
            <Grid2 container spacing={2}>
              {subServices && (
                <>
                  {subServices.map((subService, index) => (
                    <Grid2 item size={{ xs: 12, sm: 4, md: 2.5 }} key={index}>
                      <SubServicesCard
                        subService={subService}
                        serviceId={serviceId}
                      />
                    </Grid2>
                  ))}
                </>
              )}
            </Grid2>
            <Grid2
              container
              spacing={2}
              sx={{
                mt: 2,
              }}
            >
              <Grid2 item size={{ xs: 12, md: 8 }}>
                <ServiceProviderList />
              </Grid2>
              <Grid2 item size={{ xs: 12, md: 4 }}>
                <HowItWorks />
              </Grid2>
            </Grid2>
          </>
        )}
      </Box>
    </Box>
  );
}
